import { Routes } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { LoginComponent }   from './login/login.component';
import { UserComponent }   from './user/user.component';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

    canActivate() {
        return (parseInt(localStorage.getItem('selectedUser')) > 0);
    }
}

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'user',
        component: UserComponent,
        canActivate: [CanActivateViaAuthGuard]
    }
]



// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/app.routing.ts